export default __webpack_public_path__ + "static/media/ic-check.473f9b3d.svg";